/**
 * Created by xuyq on 2021/3/3.
 */
import {baseProxy,settings} from '@/myops/core'

export default class dataProxy extends baseProxy{
    constructor(request) {
        super(request);
        this.user = null;
    }
    async login({eid,password}){
        let {data:{code,data:{token}={},msg} = {}} = await this.request({
            url:settings.request.sys_prefix+"/api/auth/login",
            method:"post",
            data:{account:eid,secPwd:password}
        })

        if(code=== 200){
            return token
        } else {
            throw new Error(msg);
        }
    }
    async getUserInfo(){
        let {data:{code,data,msg}} = await this.request({
            url:settings.request.sys_prefix+"api/auth/getCurrentAuthUserInfo",
            method: 'get'
        })
        if(code=== 200){
            data.fullname = data.displayName
            data.eid = data.account
            data.personnelNumber = data.userId
            this.user = data
            return data
        } else {
            throw new Error(msg);
        }
    }
    async getDicByArray(catagroyArray){
        let {data:{code,data,msg}} = await this.request({
            url:settings.request.sys_prefix+"api/manage/dic/getDic",
            params: {dicType: catagroyArray.join(',')},
            method: 'get'
        })
        if(code=== 200){
            return data
        } else {
            throw new Error(msg);
        }
    }
    async getPermission(moduleName){
        let permissionList = (this.user.userExInfo && this.user.userExInfo.permissionList)||[]
        return permissionList.map(t=>{
            return {
                repositoryId:t
            }
        })
    }
}
